// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesCampeonatoSC = importAll(
  require.context('../../assets/CampeonatoScz', true, /\.(png|jpe?g|svg)$/)
);